import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-300">
      <div className="px-4 md:px-6 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-book-read-line text-background-50 text-lg"></i>
                </div>
                <span className="text-xl font-bold font-heading text-background-50">
                  51<span className="text-primary-500">漫画</span>
                </span>
              </Link>
              <p className="text-sm leading-relaxed text-secondary-400 max-w-md">
                51漫画是一个免费在线漫画阅读平台，提供海量热门漫画、日漫、国漫、韩漫在线阅读。支持下拉式阅读、实时阅读，无需下载即看热门漫画大全。
              </p>
            </div>

            <div>
              <h4 className="text-background-50 font-heading font-semibold mb-4 text-sm">快速导航</h4>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">漫画分类</Link></li>
                <li><Link to="/category/rexiaxuexiao" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">热血漫画</Link></li>
                <li><Link to="/category/aichun" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">恋爱漫画</Link></li>
                <li><Link to="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-background-50 font-heading font-semibold mb-4 text-sm">热门推荐</h4>
              <ul className="space-y-2">
                <li><Link to="/comic/2" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">斗破苍穹</Link></li>
                <li><Link to="/comic/8" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">一人之下</Link></li>
                <li><Link to="/comic/12" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">秦时明月</Link></li>
                <li><Link to="/comic/4" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">完美世界</Link></li>
                <li><Link to="/comic/6" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors whitespace-nowrap">狐妖小红娘</Link></li>
              </ul>
            </div>
          </div>

          <div className="border-t border-secondary-700 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-500">
              &copy; 2026 51漫画 51manhua.com - 本站所有漫画均来自互联网，版权归原作者所有
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-secondary-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-secondary-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-secondary-500 hover:text-primary-400 transition-colors whitespace-nowrap" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}